export default "__VITE_ASSET__DotVXg24__"